const API_BASE_URL = process.env.NODE_ENV === 'production' ? '' : (process.env.REACT_APP_API_BASE_URL || `http://${window.location.hostname}:5001`);

export const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

export const createRazorpaySubscription = async (userId, promoCode) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/payments/create-subscription`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, promoCode }),
    });
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error creating Razorpay subscription:', error);
    return { success: false, message: error.message };
  }
};
